export const MOON_PHASE_IDS = [
  'new_moon',
  'waxing_crescent',
  'first_quarter',
  'waxing_moon',
  'full_moon',
  'waning_moon',
  'last_quarter',
  'waning_crescent',
] as const

export type MoonPhaseId = typeof MOON_PHASE_IDS[number]

export function getMoonPhaseUrlSlug(phase: MoonPhaseId) {
  return phase.replaceAll('_', '-')
}

export function getMoonPhaseIdFromUrlSlug(slug: string): MoonPhaseId | null {
  if (slug.includes('_')) {
    return null
  }

  const phase = slug.replaceAll('-', '_') as MoonPhaseId

  return MOON_PHASE_IDS.includes(phase) ? phase : null
}
